import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    symbol: "",
    tradeName: ""
  },
  mutations: {
    setSymbol(state, symbol) {
      state.symbol = symbol;
    },
    setTradeName(state, name) {
      state.tradeName = name;
    }
  },
  actions: {

  }
})
